import * as React from 'react';

import { ContentLoadingContainer, SectionHeading } from './support-form-v2.styled';

interface IErrorViewProps {
  message: string;
}

/**
 * Full content area view with error message.
 */
export const ErrorView = ({ message }: IErrorViewProps) => (
  <ContentLoadingContainer>
    <SectionHeading data-testid="error-message">{message}</SectionHeading>
  </ContentLoadingContainer>
);
